import axios from 'axios';
import { ReservationForm, EnquiryForm } from '../types';
import emailjs from '@emailjs/browser';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Initialize EmailJS
emailjs.init('j7qgVr6ji3xocISpF');

export const apiService = {
  submitReservation: async (data: ReservationForm) => {
    try {
      const templateParams = {
        to_email: 'vs8601580444@gmail.com',
        from_name: data.reserve_name,
        from_email: data.from,
        mobile: data.mobno,
        age: data.age,
        party_size: data.person_count,
        party_type: data.party_type,
        date: data.date,
        time: data.time
      };
      
      const response = await emailjs.send(
        'service_587663s',
        'template_uxra5sb',
        templateParams
      );
      
      return { success: true, message: 'Reservation submitted successfully!' };
    } catch (error) {
      console.error('Email submission error:', error);
      throw error;
    }
  },

  submitEnquiry: async (data: EnquiryForm) => {
    if (!API_BASE_URL) {
      alert('Enquiry submitted successfully! (Demo mode)');
      return { success: true };
    }
    try {
      const response = await axios.post(`${API_BASE_URL}/enquiry`, data);
      return response.data;
    } catch (error) {
      console.error('Enquiry submission error:', error);
      throw error;
    }
  },

  generateCaptcha: async () => {
    return { captcha: Math.random().toString(36).substring(7) };
  }
};